import { useTranslation } from "react-i18next";

import ErrorBoundary from "./ErrorBoundary";

import { Content, PageContainer, SkipLink } from "./index";

import Footer from "pstat-design-system/Footer";

const PageWithoutNav = props => {
  const { t } = useTranslation();
  return (
    <PageContainer>
      <SkipLink>{t("pages.pageWithNav.skipToContent")}</SkipLink>
      <Content id="content">
        <ErrorBoundary>{props.children}</ErrorBoundary>
      </Content>
      <Footer />
    </PageContainer>
  );
};

export default PageWithoutNav;
